import { NOTIFICATION_SUCCESS } from "../Action-type/Notification-actiontype";

export const notificationSuccess = (data) => async (dispatch) => {
  dispatch({ type: NOTIFICATION_SUCCESS, payload: data });
}